import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH } from './firebase-injection';
import { needsEmailVerification } from './services/auth.utils';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AUTH);
  const router = inject(Router);

  await auth.authStateReady();

  if (auth.currentUser) {
    return true;
  }

  return router.parseUrl('/landing');
};

export const authVerifiedGuard: CanActivateFn = async () => {
  const auth = inject(AUTH);
  const router = inject(Router);

  await auth.authStateReady();

  const user = auth.currentUser;

  if (!user) {
    return router.parseUrl('/landing');
  }

  return needsEmailVerification(user) ? router.parseUrl('/verify-email') : true;
};
